import { RestaurantService } from "@bufteam/cfacorp_d2c.bufbuild_es/cfa/d2c/frontend/restaurant/v1/restaurant_service_pb";
import { Client, createClient, Interceptor } from "@connectrpc/connect";
import { createConnectTransport } from "@connectrpc/connect-web";
import { getEnvConfig } from "../config/config";
import { oktaAuth } from "../okta/okta";

// Connect uses the standard Bearer scheme, unlike the legacy Location REST API's JWTBearer.
const authInterceptor: Interceptor = (next) => async (req) => {
  const token = await oktaAuth.getAccessToken();
  if (token) {
    req.header.set("Authorization", `Bearer ${token}`);
  }
  return next(req);
};

let restaurantServiceClient: Client<typeof RestaurantService> | undefined;

export function getRestaurantServiceClient(): Client<typeof RestaurantService> {
  if (!restaurantServiceClient) {
    restaurantServiceClient = createClient(
      RestaurantService,
      createConnectTransport({
        baseUrl: getEnvConfig().D2C.baseUrl,
        interceptors: [authInterceptor],
      })
    );
  }
  return restaurantServiceClient;
}
